import React from 'react';
import { TablePagination as MUITablePagination } from '@mui/material';
import { useStyles } from './TablePagination.styles';
import { cx } from '@emotion/css';
export function TablePagination({ className, id, count, onPageChange, onRowsPerPageChange, page, rowsPerPage, rowsPerPageOptions, }) {
    const classes = useStyles();
    return (React.createElement(MUITablePagination, { className: cx(className, classes.pagination), id: id, count: count, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, component: 'div' }));
}
//# sourceMappingURL=TablePagination.js.map